import * as types from 'src/redux/constants';

export const changed = (status) => ({
  type: types.CONNECTION_CHANGED,
  payload: {
    status: status,
  },
});
